import { AllowedIncludeEntity, Entity } from "../../types/Entity";
import { DriverKpi } from "../../types/DriverKpi";
// @ts-ignore
import { setEntityModel } from "../api/apiClient";

// Constants
export const DRIVER_KPI_ENTITY: Entity = "driver_kpi";
export const INCLUDE_ENTITY_DRIVER_KPI: AllowedIncludeEntity = "driver_kpi";

// Model
export const DriverKpiModel: DriverKpi = {
  average_combined_rating: "",
  average_driver_rating: "",
  average_vehicle_rating: "",
  best_streak: 0,
  current_streak: 0,
  double_five_star_percentage: 0,
  id: "",
};

// Side effects
setEntityModel(DRIVER_KPI_ENTITY, DriverKpiModel);
